import principal from "../../assets/images/academics/faculty/musculoskeletal-pt/Dr_Sucheta_Golhar.jpeg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircleIcon from "@mui/icons-material/Circle";

const data = {
  img: principal,
  title: "Prof. Dr. Sucheta Golhar BPTh, MPTh, PhD",
  description:
    "Dear Students, splitIt is my pleasure to welcome you to Progressive Education Society’s Modern College of Physiotherapy, Pune-5. Over the last decades our Progressive Education Society, Pune-5 has leaped forward and we are among the leading institution in Maharashtra and indeed in India. Our Society had started the Bachelor of Physiotherapy (B.P.Th) course in the Academic year 2007-08 affiliated to Maharashtra University of Health Sciences, Nashik and approved by Government of Maharashtra. We believe in providing a dynamic learning environment to our students while maintaining high standards in teaching, faculty and infrastructure that are conducive to advanced learning.splitNow we are stepped forward with Master of Physiotherapy (M.P.Th) course under Maharashtra University of Health Sciences, Nashik with various specialties on PT in Cardio vascular respiratory Sciences and PT in Musculoskeletal Sciences and shortly with PT in Neurological Sciences and PT in community health Sciences. In the last five years we have come a long way but yet have miles to go and it will be possible because of those who have been with us in the past many years, those who are a energetic part of it today and those who will enthusiastically join us in coming years and will make our college excel radiantly in the years to come. Good luck and best wishes for a brilliant future. ",
  headings: ["About Principal", "Principal Profile"],
  career: [
    "Felicitated with PHYSIO RATNA AWARD at the second International Conference of Physical Therapy AIIMS 2013, DELHI.",
    "Felicitated with Community Based Rehabilitation awards at International Conference at Shirdi in 2015.",
    "Awarded with Gold and Silver medals for scoring highest marks in UG.",
    "Best speaker award at MHC International Conference, AIIMS, Delhi, 2016.",
    "Only physiotherapist to start Physiotherapy Research center in the tribal area.",
    "Lifetime Achievement Award at International Conference, Vishakhapatnam.",
    "International pride of educationist award July 2022 at Dubai University Dubai ",
  ],
};

const Principal = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Grid
          m={10}
          sx={{
            margin: "auto",
            backgroundColor: "primary.light",
            p: { xs: 1, md: 3 },
          }}
          container
          position={"relative"}
        >
          <Grid item xs={12} py="2rem" textAlign="center">
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                display: "inline",
                textDecoration: "underline",
                textUnderlineOffset: "6px",
                fontWeight: "600",
              }}
            >
              Our Principal
            </Typography>
          </Grid>

          <Grid
            container
            justifyContent={"center"}
            alignItems={"start"}
            xs={12}
            md={4}
            sx={{ mb: { xs: 5, md: 0 } }}
          >
            <Card
              sx={{
                width: { xs: "80%", md: "80%" },
                position: "sticky",
                top: "170px",
                transform: { md: "translateY(-8rem)" },
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  p: "1.5rem",
                }}
              >
                <img
                  src={principal}
                  alt="pricipal"
                  style={{
                    width: "100%",
                    height: "100%",
                    top: "30%",
                  }}
                />
                <Typography
                  variant="body2"
                  textAlign="center"
                  color={"primary.main"}
                  sx={{ px: { xs: "2rem", md: "0rem" }, pt: "10px" }}
                >
                  <span style={{ fontSize: "16px" }}>
                    Prof. Dr. Sucheta Golhar
                  </span>
                  <br />
                  <span>BPTh, MPTh, PhD</span>
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={8}>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{ px: { xs: "2rem", md: "0rem" }, color: "primary.main" }}
              fontSize={"1rem"}
            >
              Dear Students
            </Typography>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{
                px: { xs: "2rem", md: "0rem" },
                textIndent: "2rem",
                color: "primary.main",
              }}
              fontSize={"1rem"}
            >
              It is my pleasure to welcome you to Progressive Education
              Society's Modern College of Physiotherapy, Pune-5. Over the last
              decades our Progressive Education Society, Pune-5 has leaped
              forward and we are among the leading institution in Maharashtra
              and indeed in India. Our Society had started the Bachelor of
              Physiotherapy (B.P.Th) course in the Academic year 2007-08
              affiliated to Maharashtra University of Health Sciences, Nashik
              and approved by Government of Maharashtra. We believe in providing
              a dynamic learning environment to our students while maintaining
              high standards in teaching, faculty and infrastructure that are
              conducive to advanced learning.
            </Typography>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{
                px: { xs: "2rem", md: "0rem" },
                textIndent: "2rem",
                color: "primary.main",
              }}
              fontSize={"1rem"}
            >
              Now we are stepped forward with Master of Physiotherapy (M.P.Th)
              course under Maharashtra University of Health Sciences, Nashik
              with various specialties on PT in Cardio vascular respiratory
              Sciences and PT in Musculoskeletal Sciences and shortly with PT in
              Neurological Sciences and PT in community health Sciences. In the
              last five years we have come a long way but yet have miles to go
              and it will be possible because of those who have been with us in
              the past many years, those who are a energetic part of it today
              and those who will enthusiastically join us in coming years and
              will make our college excel radiantly in the years to come. Good
              luck and best wishes for a brilliant future.
            </Typography>

            <Accordion sx={{ mb: "2rem" }} defaultExpanded>
              <AccordionSummary
                id="panel1-header"
                expandIcon={<ExpandMoreIcon />}
              >
                <Typography
                  variant="body2"
                  color={"primary.main"}
                  sx={{
                    textDecoration: "underline",
                    textUnderlineOffset: "6px",
                    fontWeight: "600",
                    "&:hover": { textDecoration: "underline" },
                    fontSize: 16,
                  }}
                >
                  Career Profile:
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container columns={{ xs: 1, md: 2 }} spacing={2}>
                  <Grid item xs={12}>
                    {data.career.map((message, i) => (
                      <Stack
                        direction="row"
                        alignItems={"flex-start"}
                        justifyContent={"flex-start"}
                        mb={1}
                        sx={{ px: { xs: "2rem", md: "1rem" } }}
                        spacing={1}
                      >
                        <CircleIcon
                          fontSize="small"
                          sx={{ color: "black", scale: "80%", pt: 0.5 }}
                        />

                        <Typography
                          variant="body2"
                          textAlign="justify"
                          fontSize={"1rem"}
                          color="primary.main"
                        >
                          {message}
                        </Typography>
                      </Stack>
                    ))}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};

export default Principal;
